// prices: Array.from(Array(18)).map(_ => Math.floor(50 + Math.random() * 100))

const initialState = {
  isLoggedIn: false,
  heroes: [{
      id: 1,
      name: 'Aquaman',
      pic: 'Aquaman.jpg',
      price: 77,
      description: '',
      categories: [1, 3],
    },
    {
      id: 2,
      name: 'Batman',
      pic: 'Batman.jpg',
      price: 96,
      description: '',
      categories: [2],
    },
    {
      id: 3,
      name: 'Captain America',
      pic: 'Captain_America.jpg',
      price: 75,
      description: '',
      categories: [1],
    },
    {
      id: 4,
      name: 'Catwoman',
      pic: 'Catwoman.jpg',
      price: 126,
      description: '',
      categories: [1],
    },
    {
      id: 5,
      name: 'Cyclops',
      pic: 'Cyclops.jpg',
      price: 56,
      description: '',
      categories: [],
    },
    {
      id: 6,
      name: 'Deadpool',
      pic: 'Deadpool.jpg',
      price: 104,
      description: '',
      categories: [],
    },
    {
      id: 7,
      name: 'Hulk',
      pic: 'Hulk.jpg',
      price: 75,
      description: '',
      categories: [1],
    },
    {
      id: 8,
      name: 'Human Torch',
      pic: 'Human_Torch.jpg',
      price: 78,
      description: '',
      categories: [3],
    },
    {
      id: 9,
      name: 'Iceman',
      pic: 'Iceman.jpg',
      price: 65,
      description: '',
      categories: [3],
    },
    {
      id: 10,
      name: 'Invisible Woman',
      pic: 'Invisible_Woman.jpg',
      price: 102,
      description: '',
      categories: [],
    },
    {
      id: 11,
      name: 'Iron Man',
      pic: 'Iron_Man.jpg',
      price: 112,
      description: '',
      categories: [1, 2],
    },
    {
      id: 12,
      name: 'Mister Fantastic',
      pic: 'Mister_Fantastic.jpg',
      price: 101,
      description: '',
      categories: [2],
    },
    {
      id: 13,
      name: 'Spider Man',
      pic: 'Spider_Man.jpg',
      price: 60,
      description: '',
      categories: [1],
    },
    {
      id: 14,
      name: 'Storm',
      pic: 'Storm.jpg',
      price: 63,
      description: '',
      categories: [3],
    },
    {
      id: 15,
      name: 'Superman',
      pic: 'Superman.jpg',
      price: 116,
      description: '',
      categories: [1, 2],
    },
    {
      id: 16,
      name: 'The Flash',
      pic: 'The_Flash.jpg',
      price: 76,
      description: '',
      categories: [],
    },
    {
      id: 17,
      name: 'Thor',
      pic: 'Thor.jpg',
      price: 97,
      description: '',
      categories: [1, 2],
    },
    {
      id: 18,
      name: 'Wolverine',
      pic: 'Wolverine.jpg',
      price: 138,
      description: '',
      categories: [1],
    },
  ],
  categories: [{
      id: 1,
      name: 'Physical Work'
    },
    {
      id: 2,
      name: 'Rich'
    },
    {
      id: 3,
      name: 'Elemental Control'
    },
  ],
}

export default initialState;
